'use client'
import { useState, useEffect } from 'react';
import Image from 'next/image'
import FrontSearchBar from '@components/FrontSearchBar'


const Hero = ({ dictionary, slogan, searchParams, lang, districts }) => {

  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    // Set the initial width
    setScreenWidth(window.innerWidth);

    // Update the width on window resize
    const handleResize = () => setScreenWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className='w-full md:h-[600px] h-[400px] z-0 relative'>
      <div className="h-full">
          <Image
            src={screenWidth < 500 ? '/images/mobilebanner.webp' : '/images/banner.webp'}
            fill={"true"}
            priority={"true"}
            className='h-[600px]'
            style={{
                objectFit: 'cover'
            }}
            alt="Banner Image"
        />
      </div>
      <div className='absolute top-0 right-0 bottom-0 left-0 bg-maincolor/10'></div>
      <div className='md:block hidden absolute z-20 w-auto top-0 right-left bottom-0'>
        <Image
          src={'/images/best-agent-in-pattaya-2025-reward.jpg'}
          // fill={"true"}
          priority={"true"}
          // className='h-[400px]'
          // style={{
          //     objectFit: 'cover'
          // }}
          className='h-full w-full '
          width={488}
          height={1082}
          alt="Banner Image"
        />
      </div>
      <div className='md:hidden block absolute z-20 w-auto left-0 right-0 bottom-0'>
        <Image
          src={'/images/best-agent-in-pattaya-2025-reward-mobile.jpg'}
          // fill={"true"}
          priority={"true"}
          // className='h-[400px]'
          // style={{
          //     objectFit: 'cover'
          // }}
          className='h-full w-full '
          width={488}
          height={1082}
          alt="Banner Image"
        />
      </div>
      <FrontSearchBar lang={lang} slogan={slogan} dictionary={dictionary} />
</div>
  )
}

export default Hero